// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table, th, td {
    border: 1px solid lightgray;
    border-collapse: collapse;
}

th, td {
    text-align: center;
    vertical-align: middle;
    padding: 8px 5px;
    background-color: white;
}

thead th {
    top: -1px;
    position: sticky;
    z-index: 1;
}

    thead th.firstCol {
        z-index: 2;
    }

.firstCol {
    position: sticky;
    left: -1px;
    z-index: 1;
}

thead th, tr.oddRow td {
    background-color: rgb(234,234,234);
}

.tableDIV {
    min-height: 150px;
}
`, "",{"version":3,"sources":["webpack://./src/app/settings/rest/rest.overview/end.point.settings/mappings.rest/mapping.rest.detail.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,UAAU;AACd;;IAEI;QACI,UAAU;IACd;;AAEJ;IACI,gBAAgB;IAChB,UAAU;IACV,UAAU;AACd;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":["table, th, td {\n    border: 1px solid lightgray;\n    border-collapse: collapse;\n}\n\nth, td {\n    text-align: center;\n    vertical-align: middle;\n    padding: 8px 5px;\n    background-color: white;\n}\n\nthead th {\n    top: -1px;\n    position: sticky;\n    z-index: 1;\n}\n\n    thead th.firstCol {\n        z-index: 2;\n    }\n\n.firstCol {\n    position: sticky;\n    left: -1px;\n    z-index: 1;\n}\n\nthead th, tr.oddRow td {\n    background-color: rgb(234,234,234);\n}\n\n.tableDIV {\n    min-height: 150px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
